(() => {
  'use strict';

  if (window.__btStickyAtcGuardBound) return;
  window.__btStickyAtcGuardBound = true;

  const stickySelector = '#sticky-add-to-cart.f8ps';
  const mainBuySelector = '#main-product form.f8pr-buy-button .submit';

  let observer = null;
  let observedTarget = null;

  function getTopBoundary(sticky) {
    if (!sticky || !sticky.classList.contains('align-top')) return 0;

    const value = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--sticky_offset')
    );

    return Number.isFinite(value) ? Math.max(0, value) : 0;
  }

  function suppressSticky(sticky, suppress) {
    if (!sticky) return;

    if (suppress) {
      sticky.style.setProperty('visibility', 'hidden', 'important');
      sticky.style.setProperty('opacity', '0', 'important');
      sticky.style.setProperty('pointer-events', 'none', 'important');
    } else {
      sticky.style.removeProperty('visibility');
      sticky.style.removeProperty('opacity');
      sticky.style.removeProperty('pointer-events');
    }
  }

  function disconnectObserver() {
    if (observer) observer.disconnect();
    observer = null;
    observedTarget = null;
  }

  function bindGuard() {
    const sticky = document.querySelector(stickySelector);
    const mainBuy = document.querySelector(mainBuySelector);

    if (!sticky || !mainBuy) {
      disconnectObserver();
      return;
    }

    const topBoundary = getTopBoundary(sticky);

    const updateFromRect = rect => {
      const mainBuyHasPassed = rect.bottom <= topBoundary;
      suppressSticky(sticky, !mainBuyHasPassed);
    };

    updateFromRect(mainBuy.getBoundingClientRect());

    if (observer && observedTarget === mainBuy) return;

    disconnectObserver();

    observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (!entry) return;
      updateFromRect(entry.boundingClientRect);
    }, {
      root: null,
      rootMargin: `-${topBoundary}px 0px 0px 0px`,
      threshold: 0
    });

    observedTarget = mainBuy;
    observer.observe(mainBuy);
  }

  function rebindAfterVariantUpdate(event) {
    const rebind = () => requestAnimationFrame(bindGuard);

    if (!event || !event.promise || typeof event.promise.then !== 'function') {
      rebind();
      return;
    }

    event.promise.then(rebind, rebind);
  }

  bindGuard();
  document.addEventListener('shopify:product:select', rebindAfterVariantUpdate, true);
  document.addEventListener('shopify:section:load', bindGuard);
  window.addEventListener('resize', bindGuard, { passive: true });
})();
